import React, { useContext, useState, useEffect } from "react";
import { EmplContext } from "../Login_Page/Login_Page/LoginPage";
import configData from "../../../src/config.json";
import LoadingComponent from "../loading_component";
import Swal from "sweetalert2";
import { ColorContext } from "../../ColorContext";

const Document = ({ sharedState }) => {
  //   const { isAssetsModalOpen,setIsAssetsModalOpen, assetsFormData ,setAssetsFormData ,handleStateChange } = sharedState;

  const { resultData } = useContext(EmplContext);
  const employee_id = resultData.employee_id || 0;
  const [docs, setDocs] = useState([]);
  const [load, setLoading] = useState(true);
  const { textColor } = useContext(ColorContext);

  //   const handleStateChangeAsset = (asset)=>{
  //     // console.log("asset========",asset)
  //     setIsAssetsModalOpen(true)
  //     setAssetsFormData({
  //       requestType: "Replacements",
  //       employeeCode: "",
  //       asset: asset.asset_id,
  //       assetCode: asset.seq_no,
  //       noOfAsset: "",
  //       reason: "",
  //       photos: null,
  //     });

  //   }
  //   useEffect(() => {
  //     setLoading(true);
  //   }, []);

  const fetchData = async () => {
    try {
      const secretKey = configData.SECRET_Key;
      const requestData = { employee_id, secretKey };
      const response = await fetch(`${configData.SERVER_URL}/documents`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      const result = JSON.parse(data.result);
      // console.log("result===", result);
      if (result.success === true) {
        setDocs(result.document_records);
      }else{
        console.log("result ===", result);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [employee_id]);

  //   const deleteAsset = (index) => {
  //     fetchData(index);
  //     // setRequests((prevAssets) => prevAssets.filter((_, i) => i !== index));
  //   };

  const docSrc = (doc) => {
    if (!doc || !doc[1]) return "";
    const value = String(doc[1]);
    if (value.startsWith("/")) return `${configData.SERVER_URL}${value}`;
    return value;
  };

  const handleDownload = (type, index) => {
    const doc = docs[index];
    if (!doc) return;

    const link = document.createElement("a");
    const isUrl = doc[1] && String(doc[1]).startsWith("/");
    if (isUrl) {
      link.href = docSrc(doc);
      link.target = "_blank";
      link.download = `download.${type === "image" ? "jpeg" : "pdf"}`;
    } else if (type === "image") {
      try {
        link.href = `data:image/jpeg;base64,${atob(String(doc[1]))}`;
      } catch (e) {
        console.error("Failed to decode image base64:", e);
        return;
      }
      link.download = `image_${index}.jpeg`;
    } else if (type === "pdf") {
      try {
        link.href = `data:application/pdf;base64,${atob(String(doc[1]))}`;
      } catch (e) {
        console.error("Failed to decode pdf base64:", e);
        return;
      }
      link.download = `document_${index}.pdf`;
    }
    link.click();
  };

  return (
    <>
      {load ? (
        <div className="main-panel">
          <LoadingComponent />
        </div>
      ) : (
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="ep_content">
              <div className="row">
                <div className="col-md-12">
                  <div className="al_holi">
                    <h2 className="al_holi_tl">Docs</h2>
                  </div>
                  <div className="">
                    <div className="atable">
                      <table id="basicTable" className="basic-table">
                        <thead className="all-tables-head">
                          <tr role="row" style={{ backgroundColor: textColor }}>
                            <th className="center">
                              <span> S No </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Name </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Document </span>
                              <span />
                            </th>
                            {/* <th className="center">
                              <span> Asset Code </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Status </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Replace </span>
                              <span />
                            </th> */}
                          </tr>
                        </thead>
                        {/* <tbody>
                          {docs.map((doc, idx) => (
                            <tr key={idx} className="">
                              <td>{idx + 1}</td>
                              <td>{doc[0]}</td>
                              <td>
                                {atob(doc[1]).charAt(0) === "/" ? (
                                  <>
                                    <img
                                      src={doc[1] ? `data:image/jpeg;base64,${atob(
                                        doc[1]
                                      )}` : "vnn_1.jpg"}
                                      alt={`Document ${idx + 1}`}
                                    />
                                  </>
                                ) : (
                                  <>
                                    <iframe
                                      src={`data:application/pdf;base64,${atob(
                                        doc[1]
                                      )}`}
                                      title={`Document ${idx + 1}`}
                                      height="250"
                                    ></iframe>
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody> */}
                        <tbody>
                          {docs.map((doc, idx) => {
                            const fileData = doc[1];
                            const mimeType = doc[2] || "";
                            const isUrl = fileData && String(fileData).startsWith("/");

                            // Ensure file data is available
                            if (!fileData) {
                              return (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>{doc[0]}</td>
                                  <td>Unsupported Format</td>
                                </tr>
                              );
                            }

                            // Try-catch to handle any potential decoding errors
                            try {
                              let isImage;
                              if (isUrl) {
                                isImage = mimeType.startsWith("image/");
                              } else {
                                const decodedData = atob(fileData); // Decode the base64 string
                                // Check if the decoded data is an image by looking at its first character
                                isImage = decodedData.charAt(0) === "i";
                              }
                              const fileSrc = isUrl ? docSrc(doc) : "";

                              return (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>{doc[0]}</td>
                                  <td>
                                    {isImage ? (
                                      <div className="d-flex flex-column align-items-center">
                                        <img
                                          src={
                                            isUrl
                                              ? fileSrc
                                              : `data:image/jpeg;base64,${atob(
                                                  fileData
                                                )}`
                                          }
                                          alt={`Document ${idx + 1}`}
                                          loading="lazy"
                                          style={{
                                            width: "100px",
                                            height: "auto",
                                          }}
                                        />

                                        <button
                                          className="btn btn-primary"
                                          onClick={() =>
                                            handleDownload("image", idx)
                                          }
                                        >
                                          Download Image
                                        </button>
                                      </div>
                                    ) : !isImage ? (
                                      <>
                                        <div className="d-flex flex-column align-items-center">
                                          <iframe
                                            src={
                                              isUrl
                                                ? fileSrc
                                                : `data:application/pdf;base64,${atob(
                                                    fileData
                                                  )}`
                                            }
                                            title={`Document ${idx + 1}`}
                                            height="250"
                                            width="100%"
                                          ></iframe>

                                          <button
                                            className="btn btn-primary"
                                            onClick={() =>
                                              handleDownload("pdf", idx)
                                            }
                                          >
                                            Download PDF
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      "Unsupported Format"
                                    )}
                                  </td>
                                </tr>
                              );
                            } catch (error) {
                              return (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>{doc[0]}</td>
                                  <td>Error decoding data</td>
                                </tr>
                              );
                            }
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-12">
                  <div className="al_holi mt-5">
                    <h2 className="al_holi_tl"> Asset Request </h2>
                  </div>
                  <div className="">
                    <div className="atable">
                      <table id="basicTable" className="basic-table">
                        <thead className="all-tables-head">
                          <tr role="row" style={{ backgroundColor: textColor }}>
                            <th className="center">
                              <span> S.No </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Asset Type </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Request Type </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Asset Code </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Status </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Date </span>
                              <span />
                            </th>
                            <th className="center">
                              <span> Delete Request</span>
                              <span />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {requests.map((request, idx) => (
                            <tr key={idx} className="">
                              <td>{idx + 1}</td>
                              <td>{request.asset_allocation_id}</td>
                              <td>{request.reason}</td>
                              <td>{request.seq_no}</td>
                              <td>{request.status}</td>
                              <td>{request.last_modify_date}</td>
                              <td>
                                <button className="btn btn-danger" onClick={() => deleteAsset(request.rec_id)}>
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Document;
